import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import swal from 'sweetalert';
import axios from "axios";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";

export default function () {
  const {register, control, watch, getValues} = useForm();

  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  const [data, setData] = useState({});

  const deleteRow = (table, selector) => {
    table
      .row(selector.parents('tr'))
      .remove()
      .draw(false);
  }

  useEffect(() => {
    let table = $('#sliders').DataTable({
      "destroy": true,
      "ajax": {
        url: process.env.REACT_APP_API_URL + "sliders",
        method: 'GET',
        data: getValues(),
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "columns": [
        {data: 'id', name: 'id'},
        {data: 'name', name: 'name'},
        {data: 'page', name: 'page'},
        {data: 'product_count', name: 'product_count'},
        {data: 'position', name: 'position'},
        {
          data: 'actions', searchable: false, sortable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                            Actions
                            <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-danger me-2 mb-1 delete"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="far fa-trash-alt"></i> Delete
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "columnDefs": [{
        "targets": [2, 3],
        "orderable": false
      }],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.delete', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      $(".row-actions").fadeOut(100).addClass("hidden-actions");
      deleteSlider(id, name, table, $(this));
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/sliders/' + id + '/edit');
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

  }, [JSON.stringify(watch(['page', 'categories']))]);

  const addSlider = () => {
    navigate('/sliders/create');
  }
  const deleteSlider = (id, name, table, selector) => {
    swal({
      title: "Are you sure?",
      text: 'You want to delete slider "' + name + '"?',
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.delete('sliders/' + id, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        }).then(function (res) {
          console.log(res);
          if (res.status == 200) {
            swal('The slider "' + name + '" has been deleted!', {
              icon: "success",
            });
            deleteRow(table, selector);
            return true;
          } else {
            return false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    });
  }

  useEffect(() => {
    axios.get('/sliders/filters').then(res => {
      setData(res.data);
    });
  }, []);

  return (
    <>
      <div>
        <div className="d-flex flex-stack mb-5">
          <div className="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
            <button type="button"
                    className="btn btn-primary"
                    data-bs-toggle="tooltip"
                    title="Add slider"
                    onClick={addSlider}
            >
              Add Slider
            </button>
          </div>
        </div>
        <div className="row mt-3 mb-3">
        { console.log('asdas')}
        {  
         
          console.log(data?.categories)
          }
          <ReactSelectInput
            label="Page"
            inputClassName="col-xxl-6 col-lg-6 mb-5"
            name="page"
            placeholder="Choose"
            register={register}
            options={data?.pages}
            control={control}
          />
          <ReactMultiSelectInput
            label="Categories"
            name="categories"
            placeholder="Choose Categories"
            parentClasses="col-xxl-6 col-lg-6 mb-5"
            inputClassName="col-md-6"
            register={register}
            values={data?.categories}
            control={control}
          />
        </div>
        <table id="sliders" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th>ID</th>
            <th>Name</th>
            <th>Page</th>
            <th>Product count</th>
            <th>Position</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold"></tbody>
        </table>
      </div>
    </>
  );
}